/**
 * Otvara Gmail compose u browseru (koristi se iz Poslovanje / superadmin).
 */
export function buildGmailComposeUrl(to, subject, body) {
  const params = new URLSearchParams();
  if (to) params.set('to', to);
  if (subject != null && subject !== '') params.set('su', subject);
  if (body != null && body !== '') params.set('body', body);
  const q = params.toString();
  return `https://mail.google.com/mail/?view=cm&fs=1${q ? `&${q}` : ''}`;
}
